import { render, staticRenderFns } from "./BipTable.vue?vue&type=template&id=3fc49a93&"
import script from "./BipTable.vue?vue&type=script&lang=js&"
export * from "./BipTable.vue?vue&type=script&lang=js&"
import style0 from "./BipTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports